import comingSoonGif from "@assets/gifs/coming-soon.gif";
import { ComingSoon } from "@cpj-ai/panel-npm-package";

const PaymentsTab = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="w-7/12">
        <ComingSoon
          gif={comingSoonGif}
          title="Payment"
          subTitle="Coming Soon... "
          description="We are thrilled to announce an exciting new feature that will enhance your control and customization options! The Settings section is being redesigned to offer a seamless and intuitive experience, allowing you to personalize your panel, manage preferences, and optimize your interaction with our platform. With this update, you will have more flexibility to tailor the system to your unique needs, ensuring everything works just the way you want it to.Stay tuned as we bring you the tools "
        />
      </div>
    </div>
  );
};

export default PaymentsTab;
